import merge from 'lodash/merge';
import { StyleSheet } from 'react-native';
import { donutGraphConfig, tokens } from '../../constants';
var spacing = tokens.spacing;
export var getDonutGraphStyles = isLargeScreen => {
  return StyleSheet.create({
    donutGraphContainer: {
      alignItems: 'center',
      flexDirection: isLargeScreen ? 'row' : 'column'
    },
    donutGraphCircle: {
      maxHeight: 280,
      maxWidth: 280
    },
    showDetailsContainer: {
      flexDirection: 'row',
      alignItems: 'flex-start',
      flexGrow: 1
    },
    showDetailsItem: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: spacing.SPACING_20
    },
    showDetailsItemColor: {
      width: 16,
      height: 16,
      borderRadius: spacing.SPACING_4,
      marginRight: spacing.SPACING_8
    },
    columnContainer: {
      flex: 1,
      flexDirection: 'column',
      alignItems: 'flex-start',
      margin: spacing.SPACING_16,
      paddingVertical: spacing.SPACING_14,
      paddingHorizontal: spacing.SPACING_24
    }
  });
};
export var getDonutChartStyles = () => {
  return StyleSheet.create({
    donutChartContainer: {
      marginTop: spacing.SPACING_20
    },
    donutChartItem: {
      width: 100,
      height: 65,
      position: 'absolute',
      top: spacing.SPACING_80,
      left: spacing.SPACING_50,
      display: 'flex',
      alignItems: 'center'
    }
  });
};
export var getDonutGraphProps = (props, context) => {
  var _a;
  var theme = (props === null || props === void 0 ? void 0 : props.theme) || (context === null || context === void 0 ? void 0 : context.theme);
  var configProps = merge(donutGraphConfig === null || donutGraphConfig === void 0 ? void 0 : donutGraphConfig[theme], (_a = context === null || context === void 0 ? void 0 : context.donutGraph) === null || _a === void 0 ? void 0 : _a[theme]);
  return Object.assign(Object.assign({
    theme
  }, configProps), props);
};